
// key: string 例：'字段不应为空'
// 属性值：string 例：'字段{name}不应为空' 注：{name} 为变量，需要传入
// 应用举例：
//   方式一： $t('字段不应为空', { name: 'name' }
//   方式二： import { translate } from '@/lang/index'
//            translate('字段不应为空', { name: 'name' }）

export default {
  '数络密盾': 'GS-EDS',
  '密盾测试': 'GS-EDS Test',
  '杭州数络信息技术有限公司': 'Hzdatalink',
  '版权所有': 'All rights reserved',
  '浙ICP备15035730号-1': '浙ICP备15035730号-1',
  '是': 'Yes',
  '否': 'No',
  '网络请求失败': 'Network Request Failed',
  '重试': 'Retry',
  '没有找到该页面': 'Page not found',
  '加载中...': 'Loading...',
  '月': 'mo',
  '日': 'd',
  '分钟': 'Minute',
  '已等待{number}秒': 'Waited for {number} s',
  '已等待{number}分钟': 'Waited for {number} min',
  '已等待{number}小时': 'Waited for {number} h',
  '已等待{number}天': 'Waited for {number} d',
  '已等待{number}月': 'Waited for {number} mo',
  '已等待{number}年': 'Waited for {number} yr',


  // 底部导航栏
  '消息': 'Message',
  '文档': 'Document',
  '工作': 'Work',
  '我的': 'My',

  // 流程
  '流程': 'Workflow',
  '文件解密申请': 'File Dec',
  '信任邮件发送': 'Trusted Mail Send',
  '信任邮箱申请': 'Trusted Mail Apply',
  '文件转密级申请': 'File CL',
  '文件转透明申请': 'File Transparent',
  '文件授权申请': 'File Authorize',
  '文件外发申请': 'File Out',
  '网关信任邮件发送': 'Gw Mail Send',
  '邮件外发申请': 'Gw Mail',
  '文件清除水印申请': 'File Clear WM',
  '文件标密申请': 'File CLI',
  '新建': 'New',
  '审批中': 'Awaiting_approval',
  '已通过': 'Approved',
  '已拒绝': 'Rejected',
  '已审阅': 'Reviewed',
  '处理中': 'Processing',
  '未处理': 'Awaiting',
  '已处理': 'Processed',
  '已完成': 'Finished',
  '已取消': 'Canceled',
  '已终止': 'Terminated',
  '等待': 'Waiting',
  '发起': 'Initiate',
  '审批': 'Approve',
  '抄送': 'CC',
  '文件处理': 'File Process',
  '下载解密': 'Download',
  '发送邮件': 'Send Email',
  '文件已处理': '文件已处理',
  '邮件已发送': 'The email has been sent',
  '已下载': 'Downloaded',
  '下载文件': 'Download File',

  '任务已终止': 'Task Terminated',
  '审批任务没有执行人': 'Approval Task Has No Executor',
  '他人审批通过': 'Approved by others',
  '他人审批拒绝': 'Rejected by others',
  '他人直接审批完成': 'Direct approval completed by others',
  '他人已处理': 'Handled by others',
  '文件处理任务没有执行人': 'Document Handle Task Has No Executor',
  '流程任务发送邮件失败，status 400，response: email account has not been configured': 'Process Task Email Sending Failed, Status 400, Response: Email Account Has Not Been Configured',
  '自动发送失败：流程任务发送邮件失败，status 400，response: 535 Login Fail. Please enter your authorization code to login. More information in https://service.mail.qq.com/detail/0/53': 'Process Task Email Auto Sending Failed, Status 400, Response: Email Account Has Been Configured ErrorError',
  '文件处理已完成': 'File processing has been completed.',
  '超过处理期限': 'Exceed the processing deadline',
  '流程管理员取消流程': 'Workflow Administrator Cancels Process',
  '流程申请人取消流程': 'Workflow Applicant Cancels Process',
  '流程已取消': 'Workflow has been canceled',
  '流程已终止': 'Workflow has been terminated',
  '流程已完成': 'Workflow has been completed',
  '转为加签审批': 'Switch to add approval',



  // 登录页面
  '登录': 'Login',
  '密码': 'Password',
  '请输入账号': 'Please enter the username',
  '请输入密码': 'Please enter the password',
  '用户名不能为空': 'The username is required',
  '修改密码': 'Edit Password',

  '手机号/邮箱地址': 'Phone number/Email address',
  '首次登录或忘记密码?': 'First-time login or forgot password?',
  '我已阅读并同意': 'I have read and agree to the',
  '《软件许可与服务协议》': '《Software License and Service Agreement》',
  '和': 'and',
  '《隐私政策》': '《Privacy Policy》',
  '隐私保护指引': 'Privacy Protection Guidelines',
  '欢迎您使用': 'Welcome to use',
  '我们非常重视保护您的个人信息，请仔细阅读并理解我们的': 'We highly value the protection of your personal information. Please read and understand our',
  '请重点关注如下：': 'Please pay special attention to the following:',
  '1、为向您提供数字化办公、沟通与协同相关基本功能，我们可能会收集、使用必要的信息；': '1. To provide you with basic digital office, communication, and collaboration features, we may collect and use necessary information;',
  '2、我们可能会根据您的使用场景并经您同意后向您获取系统权限，如存储权限等；': '2. We may request system permissions (e.g., storage permissions) based on your usage scenarios and with your consent;',
  '3、我们会采取业界先进的安全措施保护您的信息安全；': '3. We implement industry-leading security measures to protect your information;',
  '4、未经您同意，我们不会从第三方处获取、共享或向其提供您的信息。': '4. We will not obtain, share, or provide your information to third parties without your consent.',
  '同意': 'Agree',
  '不同意': 'Disagree',
  '您需要同意隐私政策才能继续使用': 'You must agree to the Privacy Policy to continue using',
  '若您不同意本隐私政策，很遗憾我们将无法为您提供服务。': 'If you do not agree to this Privacy Policy, we regret that we cannot provide services to you.',
  '退出应用': 'Exit APP',
  '查看协议': 'View agreement',
  '该项不能为空': 'This field is required',
  '请输入正确的手机号或邮箱地址': 'Please enter a valid phone number or email address',

  '手机号': 'Phone number',
  '验证码': 'VCode',
  '记住账号': 'Remember account',
  '使用密码登录': 'Login with password',
  '获取验证码': 'Get VCode',
  '手机号码有误，请重填': 'Invalid phone number, please re-enter',
  '密码长度要大于等于6': 'Password length must be at least 6 characters',
  '请阅读并同意服务协议': 'Please read and agree to the service agreement',
  '手机号码有误': 'Invalid phone number',
  '验证码已发送': 'Verification code has been sent',
  '{number}秒后重新发送': 'Resend after {number} seconds',

  // 关于页
  '测试': 'Test',
  '网址': 'URL',

  // 我的页
  '关于': 'About ',
  '版本更新检查': 'Version Update Check',
  '退出登录': 'Exit',

  // 权限申请页面
  '开通文件访问权限': 'Enable file access permissions',
  '为了保证正常预览文件，请允许{name}对文件的访问权限': 'To ensure normal file preview, please allow {name} to access your files',
  '暂不': 'Not now',
  '去授权': 'Go to authorize',
  '拒绝授权': 'Deny authorization',
  '拒绝授权后，{name}将无法帮助您浏览、保存本机文档，请重新授权': 'If authorization is denied, {name} will not be able to help you browse or save local documents. Please re-authorize.',
  '不，谢谢': 'No, thank you',

  // APP.vue页面
  '检测到更新': 'Update detected',
  '稍后再说': 'Later',
  '立即下载': 'Download',
  '正在下载更新文件': 'Downloading update files',
  '再点击一次退出!': 'Press again to exit!',
  '已成功为您安装最新版本': 'The latest version has been successfully installed',
  '自动更新': 'Automatic updates',

  // 重置密码页
  '重置密码': 'Reset password',
  '请输入手机号或邮箱地址：': 'Please enter your phone number or email address:',
  '下一步?': 'Next?',
  '验证短信已发送至{phoneNumber},请输入验证码：': 'A verification message has been sent to {phoneNumber}. Please enter the verification code:',
  '没有收到?': 'Did not receive it?',
  '{number}秒后': 'After {number} seconds',
  '再次发送': 'Resend',
  '下一步': 'Next',
  '请输入新密码和确认密码：': 'Please enter a new password and confirm password:',
  '确认密码': 'Confirm',
  '提交': 'Submit',
  '验证邮件已发送至{phoneNumber}，请打开邮件验证邮箱账号，完成密码重置。': 'A verification email has been sent to {phoneNumber}. Please open the email to verify your account and complete the password reset.',
  '返回登录': 'Return to login',
  '请输入手机号或邮箱地址': 'Please enter your phone number or email address',
  '请输入验证码': 'Please enter the vcode',
  '请再次输入密码': 'Please enter your password again',
  '密码需包含“大写字母、小写字母、数字、特殊符号”中两种以上的组合，且长度在8到32位': 'The password must contain a combination of at least two of the following: uppercase letters, lowercase letters, numbers, and special characters, and be 8 to 32 characters long.',
  '两次输入密码不一致': 'The passwords entered do not match',
  '密码设置成功': 'Password set successfully',
  '密码设置失败': 'Password setup failed',

  // 设置密码页
  '设置登录密码': 'Set login password',
  '设置': 'Set',
  '密码不一致': 'Passwords do not match',
  '密码过于简单，请重新输入': 'Password is too simple, please re-enter',

  // 修改密码页
  '为您的账号': 'For your account ',
  '设置新密码': ',set a new password',
  '旧密码': 'Old',
  '请输入旧密码': 'Please enter your old password',
  '新密码': 'New',
  '请输入新密码': 'Please enter a new password',
  '请确认新密码': 'Please confirm the new password',
  '保存新密码': 'Save new password',
  '按旧密码设置': 'Set using old password',
  '按验证码设置': 'Set using verification code',
  '忘记密码': 'Forgot password',
  '点击下方按钮以获取验证码': 'Click the button below to get a verification code',
  '新密码不能与旧密码相同': 'The new password cannot be the same as the old password',
  '修改成功，需要重新登录！': 'Password changed successfully. Please login again!',
  '短信验证码已发送，请输入验证码': 'The SMS verification code has been sent. Please enter the code',
  '重新发送': 'Resend',

  // 文档页
  '已选择{number}项': '{number} items selected',
  '最近': 'Recent',
  '下载': 'Download',
  '暂无符合过滤条件的文档': 'No documents match the filter criteria',
  '暂无符合过滤条件的下载文档': 'No downloadable documents match the filter criteria',
  '打开文档': 'Open document',
  '清除记录': 'Clear history',
  '取消下载': 'Cancel download',
  '取消': 'Cancel',
  '暂无文档': 'No documents',
  '暂无下载文档': 'No downloadable documents',
  '确认': 'Confirm',
  '全选': 'Select all',
  '全不选': 'Deselect all',
  '确定清除选中文档记录': 'Are you sure you want to clear the selected document history',
  '已经到底了': 'You have reached the end',
  '文件不存在，请先重新下载！': 'The file does not exist. Please download it again!',
  '打开文件仅支持Android和IOS系统': 'Opening files is only supported on Android and iOS systems',
  '预览仅支持Android和IOS系统': 'Preview is only supported on Android and iOS systems',
  '确定删除文档：': '"Are you sure you want to delete the document:',
  '请使用{name}APP浏览文档': 'Please use the {name} app to browse documents',

  // 消息列表页
  '申请标题': 'Title',
  '申请描述': 'Desc.',
  '系统公告': 'System announcement',
  '已经到顶了': 'You have reached the top',
  '需要您审批': ' need your approval',

  // 会话列表页
  '暂无消息': 'No messages',


  // 工作页
  '我的任务': 'My tasks',
  '我的申请': 'My applications',
  '请输入审批意见': 'Please enter approval comments',
  '流程-直接完成': 'Workflow - Direct completion',
  '直接完成': 'Direct completion',
  '流程已直接完成': 'The workflow has been directly completed',
  '发起人': 'Initiator',
  '所在部门': 'Org',
  '文件': 'File',
  '预览': 'Preview',
  '已同意': 'Approved',
  '等待我审批': 'Waiting my approval',
  '拒绝': 'Reject',
  '等待我下载解密': 'Waiting my download and decryption',
  '请至pc端下载解密': 'Please download and decrypt on the PC',
  '请至pc端处理': 'Please do it on the PC',
  '下载异常': 'Download error',
  '等待文件处理': 'Waiting file processing',
  '确认同意': 'Confirm approval',
  '已同意申请': 'Application approved',
  '确认拒绝': 'Confirm rejection',
  '已拒绝申请': 'Application rejected',
  '正在载入': 'Loading',
  '常用功能：': 'Common functions',
  '最近要处理的任务：': 'Recent tasks to handle:',
  '暂无任务': 'No tasks',
  '新建中': 'Creating',
  '审批已通过': 'Approval granted',
  '审批已拒绝': 'Approval rejected',
  '审批拒绝': 'Approval rejected',
  '文件处理中': 'Processing file',
  '提交申请': 'Submit Application',

  // 组件
  '重置': 'Reset',
  '确定': 'Confirm',
  '搜索': 'Search',
  '状态': 'State',
  '类型': 'Type',
  '的': '',
  '没有符合过滤条件的申请': 'No applications match the filter condition',
  '没有申请': 'No applications',
  '没有符合过滤条件的任务': 'No tasks match the filter condition',
  '没有任务': 'No tasks',
  '请输入': 'Please enter',
  '搜索组件': 'Search component',
  '任务详情': 'Task details',
  '已等待': 'Waited for',
  '任务名称': 'Task name',
  '审阅': 'Review',
  '暂没有信息！': 'No information!',
  '信息加载失败，请确定是否网络异常！': 'Failed to load information. Please check your network connection!',

  '过滤条件：': 'Condition：',
  '全部': 'All',
  '隐私政策': 'Privacy Policy',
  '软件许可与服务协议': 'Software License and Service Agreement',

  'app需大版本更新，请立即更新到最新版本': 'A major app update is required. Please update to the latest version immediately',
  '当前已是最新版本': 'You are currently on the latest version',
  '新版本正在下载，请稍后点击': 'A new version is downloading. Please click to install once completed',

  '下拉刷新': 'Pull to refresh',
  '释放更新': 'Release to update',
  '加载完成': 'Loading complete',
  '没有数据可以加载': 'No more data to load',
  '下拉加载更多': 'Pull down to load more',
  '释放加载更多': 'Release to load more',
  '上拉加载': 'Pull up to load',
  '已经到底了!': 'You have reached the bottom!',
  '上拉更新': 'Pull up to update',
  '已经最新了!': 'Already up to date!',
  '更新完成': 'Update complete',

  // 错误
  '网络异常,请检查网络': 'Network Error',
  '服务器访问异常': 'Request failed with status code 502',
  '连接服务器超时({number}秒)': 'Error: timeout of {number} seconds exceeded',
  '网页未找到': '404 Not Found',
  '无法连接服务器': 'Network Error',
  '此手机号暂未注册': 'this number is not found',
  '手机号日频率限制': 'daily frequency limit for phone numbers',
  '手机号1小时频率限制': 'an hour frequency limit for phone numbers',
  '请等待60s后再获取新验证码': 'to receive a new code, wait at least 60 seconds',
  '此邮箱地址暂未注册': 'this email is not found',
  '发送验证邮件失败，请稍后再试': 'failed to send verification mail. please try again later',
  '账号被锁定, 请使用密码找回功能重置密码': 'the user account has been locked',
  '无权登录，请联系管理员授权': 'user has unknown role',
  '用户名或密码错误': 'incorrect username or password',
  '没有找到该用户': 'user not found',
  '没有找到该用户,请重新登录': 'account not found',
  '您没有权限登录!': 'no rights or no roles',
  '当前登录无效!': 'token is expired',
  '无权访问当前厂家，请重新登录': 'tenant access denied',
  '用户密码已修改，请重新登录': 'user password changed',
  '您已经成为厂家正式用户，请重新登录': 'please switch to actual tenant',
  '当前账号不属于任何租户，租户信息可能正在审核中，请等待!': 'the user account no tenant',
  '验证码错误': 'verification code error',
  '登录已过期，需要重新登录': 'signature is invalid',
  '请不要非正常切换页面': 'change page abnormally',
  '消息创建失败:服务端无错误信息': 'error',
  '没有找到可以上传的文件': 'no file found, the filename should like file1,file2,file3...',
  '未能解析的错误': 'unknown error',
  '客户eds-server服务地址未指定': 'customer\'s eds-server API URL not specified',
  '任务状态错误，该任务已被处理': 'task state error',
  '该流程不存在，可能已被申请人删除': 'workflow not found',
  '流程状态错误': 'workflow state error',
  '无法连接至企业端接口服务': 'unable to connect to enterprise interface service',
  '流程不存在': 'workflow not found',
  '读取权限异常': 'read permission error',
  '文档操作权限申请成功': 'document operation permission request succeeded',
  '文档操作权限申请失败，影响文档预览功能': 'document operation permission request failed, affecting document preview functionality',
  '文件[{name}] 下载失败，请稍后再试。': 'File [{name}] download failed. Please try again later.',
  '文件[{name}] 打开失败，可能该加密文件不属于当前企业': 'Failed to open file [{name}]. The encrypted file may not belong to the current enterprise.',
  '没有权限预览，因为无租户信息': 'No permission to preview due to missing tenant information.',
  '服务连接失败': 'Service connection failed',
  '客户的EDS服务器App-Key未提供': 'customer\'s eds-server app-key not specified',
  '获取App-Key错误': '获取App-Key错误',
  '文件不存在': 'file does not exist',
  '检查文件时出错': 'error checking file',
  '验证失败，请重新登录': 'Signature is invalid,please log in again.',
  '客户用户不存在': 'customer user not found',
  '记录不存在': 'record not found',
  '生成用户令牌出错': 'generate user token error',
  '当前版本不支持': 'the interface does not support the current version',

}


